import * as React from 'react';
import LightSweep from '@/components/LightSweep';
import '@/components/SecondMainPageSkeleton/index.css';

interface IProps {
  headerHeight?: number;
  showSearchBar?: boolean;
  useBigIconSkeleton?: boolean;
  showFilterBar?: boolean;
  headerPic?: string;
}

const rightLines = [...Array(2)];
const filterBarItems = [...Array(4)];

export default class SecondMainPageSkeleton extends React.Component<IProps> {
  itemCardRenderer = () => {
    const { useBigIconSkeleton = false } = this.props;
    if (useBigIconSkeleton) {
      return (
        // ----- mpweb适配origin -----
        // <view key="" className="bonepage-list-card-big-icon">
        // ----- mpweb适配change -----
        <view className="bonepage-list-card-big-icon">
          {/*// ----- mpweb适配       -----*/}
          <view className="bonepage-list-big-icon-img" />
          <view className="bonepage-list-big-icon-title" />
          <view className="bonepage-list-big-icon-subtitle" />
        </view>
      );
    }
    return (
      // ----- mpweb适配origin -----
      // <view key="" className="bonepage-list-card">
      // ----- mpweb适配change -----
      <view className="bonepage-list-card">
        {/*// ----- mpweb适配       -----*/}
        <view className="left" />

        <view className="right">
          {rightLines.map((_, lineIndex) => (
            <view key={lineIndex} className={`line line-${lineIndex + 1}`} />
          ))}
        </view>
      </view>
    );
  };
  render() {
    const {
      showSearchBar = false, headerHeight = 233, showFilterBar = true, headerPic = 'assets://placeholder/icon_placeholder_16:9.png',
    } = this.props;
    return (
      <view className="bonepage-container">
        <view className="header-container" style={{ height: headerHeight }}>
          {showSearchBar && (
            <view
              className="address-view"
              style={{ marginTop: Mach.env.statusBarHeight, marginLeft: Mach.env.screenWidth - 162 }}
            />
          )}
          <view>
            <image className="bonepage-header" src={headerPic} />
            {showSearchBar && <view className="search-bar-container" />}
          </view>
        </view>
        <view className="absolute-list">
          {showFilterBar && (
            <view className="filter-bar-container">
              {filterBarItems.map((_, index) => (
                <view key={index} className={`filter-bar-item filter-bar-item-${index + 1}`} />
              ))}
            </view>
          )}
          {/*// ----- mpweb适配origin -----*/}
          {/* {[...Array(5)].map(this.itemCardRenderer)} */}
          {/*// ----- mpweb适配change -----*/}
          {[
            'skeleton-card:0',
            'skeleton-card:1',
            'skeleton-card:2',
            'skeleton-card:3',
            'skeleton-card:4',
          ].map((skeletonCardKey) => React.cloneElement(
            this.itemCardRenderer(),
            { key: skeletonCardKey }
          ))}
          {/*// ----- mpweb适配       -----*/}
        </view>
        <LightSweep style={{ position: 'absolute' }} />
      </view>
    );
  }
}
